import { z } from 'zod';

/** Perfis que vêm de fábrica. A Triagem é a porta de entrada e não pode ser arquivada. */
export const AGENT_PROFILE_KEYS = ['triage', 'support', 'finance', 'sales', 'general'] as const;
export const TRIAGE_PROFILE_KEY = 'triage';
/** Identificador de perfil: os de fábrica e os criados pela equipe (gerado a partir do nome). */
export type AgentProfileKey = string;
export const profileKeySchema = z.string().regex(/^[a-z][a-z0-9_]{1,39}$/, 'Identificador inválido');

/** "Retenção & Cancelamento" → "retencao_cancelamento". */
export function profileKeyFromName(name: string): string {
  const base = name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 36);
  return /^[a-z]/.test(base) ? base : `p_${base}`.slice(0, 36);
}

export const AI_PROVIDERS = ['openai', 'gemini'] as const;
export type AiProvider = (typeof AI_PROVIDERS)[number];

export const AI_PROVIDER_LABELS: Record<AiProvider, string> = {
  openai: 'OpenAI',
  gemini: 'Google Gemini',
};

/** Ferramentas que o motor pode expor a um perfil. Toda chamada passa pelo Gateway de Segurança. */
export const AGENT_TOOLS = [
  'knowledge_search',
  'transfer_to_human',
  'transfer_to_profile',
  'identificar_cliente',
  'consultar_contratos',
  'consultar_faturas',
  'obter_segunda_via',
  'consultar_conexao',
  'consultar_incidentes',
  'abrir_chamado',
  'consultar_chamados',
] as const;
export type AgentTool = (typeof AGENT_TOOLS)[number];

export const AGENT_TOOL_LABELS: Record<AgentTool, string> = {
  knowledge_search: 'Busca na base de conhecimento',
  transfer_to_human: 'Transferir para atendente',
  transfer_to_profile: 'Transferir para outro perfil',
  identificar_cliente: 'Identificar cliente',
  consultar_contratos: 'Consultar contratos',
  consultar_faturas: 'Consultar faturas',
  obter_segunda_via: 'Obter segunda via',
  consultar_conexao: 'Consultar conexão',
  consultar_incidentes: 'Consultar incidentes',
  abrir_chamado: 'Abrir chamado',
  consultar_chamados: 'Consultar chamados',
};
